import React from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useAdmin } from '@/contexts/AdminContext';
import { UserX, AlertTriangle } from 'lucide-react';

const AdminImpersonationBanner = () => {
  const { isImpersonating, targetUser, endImpersonation } = useAdmin();

  if (!isImpersonating || !targetUser) {
    return null;
  }

  return (
    <Alert className="border-red-300 bg-red-100 text-red-900 rounded-none border-x-0 border-t-0 sticky top-0 z-50 shadow-lg">
      <AlertTriangle className="h-5 w-5 text-red-600" />
      <AlertDescription className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          <span className="font-bold text-lg">
            ⚠️ ADMIN IMPERSONATION MODE
          </span>
          <span className="font-medium">
            - Viewing as: {targetUser.email}
          </span>
        </div>
        <Button
          size="sm"
          variant="destructive"
          onClick={endImpersonation}
        >
          <UserX className="h-4 w-4 mr-2" />
          End Impersonation
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default AdminImpersonationBanner;